/**
 * SortableTh — 누르면 정렬이 도는 표 머리 칸(차례는 tableSort.nextSort).
 *
 * 얼굴은 프리셋 표(PresetPage/PresetTable.js SortIcon)를 따른다 — 정렬 중이면 초록(primary) 꺾쇠
 * 위·아래, 아니면 옅은 회색 표시. 옅은 회색 표시만 글자 「↕︎」 대신 같은 모양의 아이콘을 쓴다:
 * 글자로 두면 머리 칸의 글자가 「학생명↕︎」 이 되어, 표를 복사해 붙여 넣을 때 머리에 기호가 딸려 간다.
 *
 * 칸 전체(th)가 누르는 자리다 — 글자만 눌리면 칸 가장자리를 누른 손이 헛돈다. 안의 button 은
 * 키보드로 닿기 위한 것이라 자기 onClick 을 갖지 않는다: 버튼의 클릭(Enter·Space 포함)이 th 로
 * 올라와 한 번만 돈다.
 *
 * 머리 줄 바탕(bg-gray-50)에서 한 단 진한 회색으로 hover 한다 — 프리셋 표도 자기 바탕(gray-100)에서
 * 한 단(gray-200)만 올린다.
 */
import { ChevronDown, ChevronUp, ChevronsUpDown } from 'lucide-react';
import { ariaSortOf } from './tableSort';

// 다음에 누르면 무엇이 되는지 — 세 번째 누름이 「기본」 이라는 것은 눌러 보기 전에는 모른다
const NEXT_HINT = {
  none: '누르면 내림차순',
  desc: '누르면 오름차순',
  asc: '누르면 기본 순서',
};

export default function SortableTh({ sortKey, sort, onSort, className = '', children }) {
  const order = sort?.key === sortKey ? sort.order : null;
  let mark = <ChevronsUpDown aria-hidden="true" className="size-3 shrink-0 text-gray-300" />;
  if (order === 'asc') mark = <ChevronUp aria-hidden="true" className="size-3 shrink-0 text-primary" />;
  if (order === 'desc') mark = <ChevronDown aria-hidden="true" className="size-3 shrink-0 text-primary" />;
  return (
    <th
      scope="col"
      aria-sort={ariaSortOf(sort, sortKey)}
      onClick={() => onSort(sortKey)}
      className={`${className} cursor-pointer select-none hover:bg-gray-100`}
    >
      <button type="button" title={NEXT_HINT[order ?? 'none']} className="inline-flex items-center gap-1 whitespace-nowrap">
        {children}
        {mark}
      </button>
    </th>
  );
}
